const normalizeStatus = (booking) =>
  String(booking?.status || booking?.bookingStatus || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");

const isCanceledStatus = (status) =>
  status === "canceled" || status === "cancelled";

export const isUserCancelledBooking = (booking) => {
  if (!booking) return false;

  const cancelledBy = String(booking?.cancelledBy || "").toLowerCase().trim();
  if (cancelledBy === "user") return true;
  if (cancelledBy === "admin" || cancelledBy === "photographer") return false;

  const displayStatus = String(booking?.displayStatus || "").toLowerCase();
  if (displayStatus.includes("portal cancel")) return false;

  return isCanceledStatus(normalizeStatus(booking));
};

export const getUserCancelledBookingTitle = (booking, defaultTitle = "") =>
  isUserCancelledBooking(booking)
    ? "Booking was canceled by the user"
    : defaultTitle;
